(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blom-formats')) {
    customElements.define(
      'blom-formats',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();

          const options = {
            signal: this.controller.signal
          };

          const track = this.querySelector('.bf__track');
          const buttons = this.querySelectorAll('[data-step]');

          const update = () => {
            buttons.forEach((button) => {
              button.disabled =
                Number(button.dataset.step) < 0
                  ? track.scrollLeft <= 2
                  : track.scrollLeft + track.clientWidth >=
                    track.scrollWidth - 2;
            });
          };

          buttons.forEach((button) => {
            button.addEventListener(
              'click',
              () => {
                const card = track.querySelector('.bf__item');

                if (!card) return;

                track.scrollBy({
                  left:
                    Number(button.dataset.step) *
                    (card.getBoundingClientRect().width + 14),
                  behavior: matchMedia(
                    '(prefers-reduced-motion: reduce)'
                  ).matches
                    ? 'instant'
                    : 'smooth'
                });
              },
              options
            );
          });

          track.addEventListener('scroll', update, {
            ...options,
            passive: true
          });

          this.observer = new ResizeObserver(update);
          this.observer.observe(track);

          update();
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
